import { IDocumentType } from './document-uploader-type-selector.models';

export const ProformaInvoiceRef: string = 'd91e5bd0-4c3d-11f0-a12b-005056bd8d41';
export const CommercialInvoiceRef: string = '5c7bd5e2-4c52-11f0-a12b-005056bd8d41';
export const PackingListRef: string = 'd20ecab2-4b79-11f0-a12b-005056bd8d41';
export const PhytosanitaryCertificateRef: string = '1665de3a-4c3e-11f0-a12b-005056bd8d41';
export const InternationalSanitaryCertificateRef: string = '3df3f781-4c3e-11f0-a12b-005056bd8d41';
export const InternationalVeterinaryCertificateRef: string = '57403b08-4c51-11f0-a12b-005056bd8d41';
export const CertificateOfOriginRef: string = '70cfe79e-4c51-11f0-a12b-005056bd8d41';
export const CertificateOfOriginEur1Ref: string = '99ab469a-4c51-11f0-a12b-005056bd8d41';
export const GeologicalConclusionRef: string = 'b0a79d3c-4c51-11f0-a12b-005056bd8d41';
export const ForeignEconomicContractRef: string = 'c35c73a8-4c51-11f0-a12b-005056bd8d41';
export const AddendumToForeignEconomicContractRef: string = 'f4b9b7c0-4c51-11f0-a12b-005056bd8d41';
export const OtherRef: string = '1f60cbbf-4c52-11f0-a12b-005056bd8d41';

export const documentUploaderTypes: IDocumentType[] = [
  {
    Ref: ProformaInvoiceRef,
    Code: 325,
    Label: 'Рахунок-Проформа (Proforma Invoice)',
  },
  {
    Ref: CommercialInvoiceRef,
    Code: 380,
    Label: 'Рахунок-Фактура (Commercial Invoice)',
  },
  {
    Ref: PackingListRef,
    Code: 271,
    Label: 'Пакувальний лист (Packing list)',
  },
  {
    Ref: PhytosanitaryCertificateRef,
    Code: 851,
    Label: 'Фітосанітарний Сертифікат',
  },
  {
    Ref: InternationalSanitaryCertificateRef,
    Code: 852,
    Label: 'Міжнародний Санітарний Сертифікат',
  },
  {
    Ref: InternationalVeterinaryCertificateRef,
    Code: 853,
    Label: 'Міжнародний Ветеринарний Сертифікат',
  },
  {
    Ref: CertificateOfOriginRef,
    Code: 861,
    Label: 'Сертифікат про походження товару',
  },
  {
    Ref: CertificateOfOriginEur1Ref,
    Code: 954,
    Label: 'Сертифікат про походження товару EUR-1',
  },
  {
    Ref: GeologicalConclusionRef,
    Code: 3023,
    Label: 'Геологічний Висновок',
  },
  {
    Ref: ForeignEconomicContractRef,
    Code: 4100,
    Label: 'Договір (Контракт) ЗЕД (Sales Contract)',
  },
  {
    Ref: AddendumToForeignEconomicContractRef,
    Code: 4103,
    Label: 'Додаток/Специфікація до Договору ЗЕД',
  },
  {
    Ref: OtherRef,
    Code: 9000,
    Label: 'Інше',
  },
];
